/** Bloc de section teinté (titre en capitales + contenu) — utilisé par les vues Travaux admin/portail. */
const TONES = {
  amber: "bg-amber-50 border-amber-200",
  blue: "bg-blue-50 border-blue-200",
  emerald: "bg-emerald-50 border-emerald-200",
  violet: "bg-violet-50 border-violet-200",
  rose: "bg-rose-50 border-rose-200",
  cyan: "bg-cyan-50 border-cyan-200",
  indigo: "bg-indigo-50 border-indigo-200",
  slate: "bg-slate-50 border-slate-200",
};

export function ToneSection({ title, tone, children }) {
  return (
    <div className={`border rounded-xl p-3 space-y-2 ${TONES[tone] || TONES.slate}`}>
      <div className="text-xs font-bold uppercase tracking-wider text-slate-700">{title}</div>
      {children}
    </div>
  );
}
